import React from "react";
import styles from "../InverluxApps.module.css";

const ChromeWebStoreButton = () => (
  <button
    className={styles.storeButton}
    type="button"
    disabled
    title="Chrome Web Store listing coming soon"
  >
    <span className={styles.storeButtonIcon} aria-hidden="true">
      +
    </span>
    <span>
      <span className={styles.storeButtonLabel}>Chrome Web Store</span>
      <span className={styles.storeButtonStatus}>Listing coming soon</span>
    </span>
  </button>
);

export default ChromeWebStoreButton;
